

















import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
    props: {
        speed: {
            type: Number,
            default: 0,
        },
    },
    setup(props) {
        const rotation = computed(() => (Math.min(100, Math.max(0, props.speed)) / 100 - 1) * 180);

        return {
            rotation,
        };
    },
});
